module.exports = __webpack_public_path__ + "static/media/sunyiwen_match_03.6a001e62.png";